import { render, staticRenderFns } from "./ListIncidenciaAlbaranPage.vue?vue&type=template&id=2390b816"
import script from "./ListIncidenciaAlbaranPage.vue?vue&type=script&lang=js"
export * from "./ListIncidenciaAlbaranPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports